import React from 'react'
import { User, UserRoleKind } from '../../../api/users'
import useUsersTableData, { UserListRowKeys } from './hooks/use-users-table-data'
import Table from '../../table'

interface UsersTableProps {
  users: User[]
  roleKind: UserRoleKind | 'offlineWorker' | 'employerWorker'
  selectedUserIds?: string[]
  onSelectionChange?: (selectedIds: string[]) => void
  enableSelection?: boolean
}

const UsersTable: React.FC<UsersTableProps> = ({
  users,
  roleKind,
  selectedUserIds = [],
  onSelectionChange,
  enableSelection = false,
}) => {
  const { columns, users: usersAsRows } = useUsersTableData(
    users,
    roleKind === 'offlineWorker' ? 'worker' : roleKind,
    columnsByRoles[roleKind],
    enableSelection,
    selectedUserIds,
    onSelectionChange,
  )

  return (
    <Table
      columns={columns}
      data={usersAsRows}
      noDataMessage="Aucun Utilisateur à afficher"
      tableClassName="overflow-visible"
      className="overflow-visible"
      dataTest="users-table"
    />
  )
}

export default UsersTable

const columnsByRoles: Record<UsersTableProps['roleKind'], UserListRowKeys[]> = {
  worker: [
    'lastName',
    'firstName',
    'internalRef',
    'weeklyHoursWorked',
    //'internalComment',
    //'internalInformation',
    'email',
    'associationStatus',
    //'availability',
    'qrCode',
    //'editUser',
    //'resendInvitation',
    //'discontinueAssociation',
    'actions',
  ],
  employerWorker: ['lastName', 'firstName', 'qrCode'],
  offlineWorker: [
    'lastName',
    'firstName',
    'internalRef',
    'weeklyHoursWorked',
    'qrCode',
    //'editUser',
    //'discontinueAssociation',
    'actions',
  ],
  employerMember: [
    'lastName',
    'firstName',
    'email',
    'organizationRole',
    'roleStatus',
    //'editUser',
    //'resendInvitation',
    //'discontinueAssociation',
    'actions',
  ],
  interimAgencyMember: [
    'lastName',
    'firstName',
    'email',
    'roleStatus',
    //'resendInvitation',
    //'discontinueAssociation',
    'actions',
  ],
  superAdmin: ['lastName', 'firstName', 'email', 'actions'],
}
